export const START_LOAD = 'all_teams/START_LOAD';
export const FINISH_LOAD = 'all_teams/FINISH_LOAD';

const initialState = {
    loading:false,
    all_teams:null
};
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case START_LOAD:  return {...state, loading:true};
        case FINISH_LOAD:  return {...state, loading:false, all_teams:action.payload};
        default: return state;
    }
}